import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { CSVLink } from 'react-csv'
import Popup from 'reactjs-popup'
import { Form, Field, Formik } from 'formik'
import memoize from 'memoize-one'
import classNames from 'classnames'

import { ResourceModel } from '@modules/resource/resource.module'
import CheckboxTree from '@modules/form/components/input/CheckboxTree'
import 'react-checkbox-tree/src/scss/react-checkbox-tree.scss';
import './AsyncDataExportOverlay.scss'

class AsyncDataExportOverlay extends Component {

	static propTypes = {
		title: PropTypes.string,
		mapDataToCSV: PropTypes.func.isRequired,
		mapDataToCSVFilename: PropTypes.func,
		// filename is ignored if mapDataToCSVFilename is included
		filename: PropTypes.string,
		fetchData: PropTypes.func.isRequired,
		Model: PropTypes.instanceOf(ResourceModel).isRequired,
	};
	static defaultProps = {
		title: 'Export Data',
	}

	get initialState() { 
		return {
			CSVData: [], 
			isFetching: false,
			fetchError: false,
			downloadReady: false,
		}
	}

	constructor(props) {
		super(props);
		this.state = this.initialState;
	}

	async downloadCSV(paths) {
		const { fetchData, mapDataToCSV } = this.props;
		var data;

		// 1. initialise fetching state
		await this.setState(this.initialState);

		// 2. fetch data
		try {
			await this.setState({
				isFetching: true,
			});
			data = await fetchData();
		}
		catch(err) {
			await this.setState({ 
				fetchError: true, 
				isFetching: false 
			});
			return;
		}

		// 3. call mapdata func on data
		const CSVData = mapDataToCSV(data, paths);
		
		// 4. update final state with data
		await this.setState({ 
			downloadReady: true,
			isFetching: false, 
			CSVData,
		});

		// 5. trigger click on download link
		this.refs.csvLink.link.click();

	}

	get buttonLabel() {
		const { isFetching, fetchError } = this.state;
		switch(true) {
			case fetchError:
				return 'Error'
			case isFetching:
				return 'Creating CSV...';
			default: 
				return 'Export CSV';
		}
	}

	getInitialValues = memoize(
		Model => ({ fieldChecklist: Model.getLeafPaths(f => f.toCSV.include != 'never') })
	);

	getNodes = memoize(Model => Model.getFieldChecklistNodes())

	render() {
		const { 
			title,
			filename,
			className, // TODO: figure neat way to get html friendly props
			Model,
		} = this.props;

		const {
			CSVData,
			downloadReady
		} = this.state;

		const ExportButton = <button type="button" className="btn btn-primary">{this.buttonLabel}</button>;

		const initialValues = this.getInitialValues(Model);
		const nodes = this.getNodes(Model);

		return (
			<React.Fragment>
				{ downloadReady && 
					<CSVLink 
			 			ref="csvLink" 
			 			style={{display: 'none'}} 
			 			data={CSVData} 
			 			filename={filename ? filename : 'data-export.csv'} 
			 		/>
			 	}
				<Popup 
					trigger={ExportButton} 
					closeOnDocumentClick={false}
					modal
				>
	    		{close => (
	    			<div className="modal">
			        <a className="close" onClick={close}>&times;</a>
			        <div className="header"><h2>{title}</h2></div>
			        <div className="content">
			          <Formik
			          	initialValues={initialValues}
			          	onSubmit={(values, actions) => {
			          		// close lightbox
			          		close();
			          		// download CSV
			          		this.downloadCSV(values.fieldChecklist);
			          	}}
			          >
			          	<Form>
			          		<b className="selectFieldsLabel">Select Fields:</b>
			          		<Field 
			          			name="fieldChecklist" 
			          			component={CheckboxTree} 
			          			nodes={nodes} 
			          		/>
			          		<div className="submitWrap">
			          			<button type="submit">Submit</button>
			          		</div>
			          	</Form>
			          </Formik>
			        </div>
			      </div>
	    		)}
	  		</Popup>
			</React.Fragment> 
  	)

	}
}

export default AsyncDataExportOverlay;


// WEBPACK FOOTER //
// ./src/components/DataExportOverlay/AsyncDataExportOverlay.jsx